export const responsiveGutter = { xs: 8, sm: 16, md: 24, lg: 32 };

export const fullSpan = {
  lg: { span: 24 },
  ms: { span: 24 },
  sm: { span: 24 },
  xs: { span: 24 },
};

export const twentySpan = {
  lg: { span: 20 },
  ms: { span: 20 },
  sm: { span: 20 },
  xs: { span: 20 },
};

export const nineteenSpan = {
  lg: { span: 19 },
  ms: { span: 19 },
  sm: { span: 19 },
  xs: { span: 19 },
};

export const seventeenSpan = {
  lg: { span: 17 },
  ms: { span: 17 },
  sm: { span: 17 },
  xs: { span: 17 },
};

export const sixteenSpan = {
  lg: { span: 16 },
  ms: { span: 16 },
  sm: { span: 16 },
  xs: { span: 16 },
};

export const fifteenSpan = {
  lg: { span: 15 },
  ms: { span: 15 },
  sm: { span: 15 },
  xs: { span: 15 },
};

export const fourteenSpan = {
  lg: { span: 14 },
  ms: { span: 14 },
  sm: { span: 14 },
  xs: { span: 14 },
};

export const thirteenSpan = {
  lg: { span: 13 },
  ms: { span: 13 },
  sm: { span: 13 },
  xs: { span: 13 },
};

export const halfSpan = {
  lg: { span: 12 },
  ms: { span: 12 },
  sm: { span: 12 },
  xs: { span: 12 },
};

export const eleveenSpan = {
  lg: { span: 11 },
  ms: { span: 11 },
  sm: { span: 11 },
  xs: { span: 11 },
};

export const tenSpan = {
  lg: { span: 10 },
  ms: { span: 10 },
  sm: { span: 10 },
  xs: { span: 10 },
};

export const trioSpan = {
  lg: { span: 8 },
  ms: { span: 8 },
  sm: { span: 8 },
  xs: { span: 8 },
};

export const saptaSpan = {
  lg: { span: 7 },
  ms: { span: 7 },
  sm: { span: 7 },
  xs: { span: 7 },
};

export const quaterSpan = {
  lg: { span: 6 },
  ms: { span: 6 },
  sm: { span: 6 },
  xs: { span: 6 },
};

export const fifthSpan = {
  lg: { span: 5 },
  ms: { span: 5 },
  sm: { span: 5 },
  xs: { span: 5 },
};

export const fifthResponsiveSpan = {
  xl: { span: 5 },
  lg: { span: 5 },
  md: { span: 8 },
  sm: { span: 12 },
  xs: { span: 24 },
};

export const hexSpan = {
  lg: { span: 4 },
  ms: { span: 4 },
  sm: { span: 4 },
  xs: { span: 4 },
};

export const triSpan = {
  lg: { span: 3 },
  ms: { span: 3 },
  sm: { span: 3 },
  xs: { span: 3 },
};

export const octaSpan = {
  lg: { span: 2 },
  ms: { span: 2 },
  sm: { span: 2 },
  xs: { span: 2 },
};

export const hexResponsiveSpan = {
  lg: { span: 4 },
  ms: { span: 12 },
  sm: { span: 12 },
  xs: { span: 24 },
};

export const quaterResponsiveSpan = {
  lg: { span: 6 },
  ms: { span: 8 },
  sm: { span: 12 },
  xs: { span: 24 },
};

export const trioResponsiveSpan = {
  lg: { span: 8 },
  ms: { span: 8 },
  sm: { span: 12 },
  xs: { span: 24 },
};

export const halfResponsiveSpan = {
  lg: { span: 12 },
  ms: { span: 12 },
  sm: { span: 24 },
  xs: { span: 24 },
};

export const threeQuarterResponsiveSpan = {
  lg: { span: 16 },
  ms: { span: 16 },
  sm: { span: 24 },
  xs: { span: 24 },
};

export const leftDividerSpan = {
  lg: { span: 10 },
  ms: { span: 10 },
  sm: { span: 24 },
  xs: { span: 24 },
};

export const centerDividerSpan = {
  lg: { span: 2 },
  ms: { span: 2 },
  sm: { span: 24 },
  xs: { span: 24 },
};

export const rightDividerSpan = {
  lg: { span: 12 },
  ms: { span: 12 },
  sm: { span: 24 },
  xs: { span: 24 },
};
